"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var html_definitions_1 = require("./html-definitions");
var ToolbarComponent = /** @class */ (function () {
    function ToolbarComponent() {
        var _this = this;
        this.enableiv = false;
        this.view =
            window.rslidy.utils.appendHtmlString(document.querySelector('#rslidy-column-flex'), html_definitions_1.toolbar_html);
        this.view
            .querySelector("#rslidy-button-overview")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return _this.overviewToggleClicked(); }); });
        this.view
            .querySelector("#rslidy-button-toc")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return _this.tocToggleClicked(); }); });
        this.view
            .querySelector("#rslidy-button-help")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return _this.helpToggleClicked(); }); });
        this.view
            .querySelector("#rslidy-button-first")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return window.rslidy.content.navFirst(); }); });
        this.view
            .querySelector("#rslidy-button-previous")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return window.rslidy.content.navPrevious(true); }); });
        this.view
            .querySelector("#rslidy-button-next")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return window.rslidy.content.navNext(true); }); });
        this.view
            .querySelector("#rslidy-button-last")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return window.rslidy.content.navLast(); }); });
        this.view
            .querySelector("#rslidy-button-hide")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return _this.showHideToggleClicked(); }); });
        this.view
            .querySelector("#rslidy-button-show")
            .addEventListener("click", function () { return _this.showHideToggleClicked(); });
        this.view
            .querySelector("#rslidy-button-all")
            .addEventListener("click", function () { return _this.displayToggleClicked(); });
        this.view
            .querySelector("#rslidy-timer")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return window.rslidy.toggleTimer(); }); });
        this.view
            .querySelector("#rslidy-slide-caption")
            .addEventListener("click", function () { return _this.closeMenuOnBlur(function () { return _this.tocToggleClicked(); }); });
        this.view
            .querySelector("#rslidy-button-menu")
            .addEventListener("click", function () { return _this.menuToggleClicked(window.rslidy.MENU); });
        this.view
            .querySelector("#rslidy-button-print")
            .addEventListener("click", function () { return _this.menuToggleClicked(window.rslidy.PRINT_MENU); });
        this.view
            .querySelector("#rslidy-slide-input")
            .addEventListener("keyup", function (e) { return _this.closeMenuOnBlur(function () { return window.rslidy.slideInputKeyPressed(e); }); });
        // Only allow numbers for slide input
        window.rslidy.utils.setInputFilter(document.getElementById("rslidy-slide-input"), function (value) { return /^\d*$/.test(value); });
        document.getElementById("rslidy-help")
            .addEventListener("mouseup", function (e) { return _this.closeHelpOnBlur(e); });
        if (window.rslidy.start_with_toolbar_minimized)
            this.showHideToggleClicked();
    }
    // ---
    // Description: Called whenever the overview button is clicked.
    // ---
    ToolbarComponent.prototype.overviewToggleClicked = function () {
        window.rslidy.utils.switchElementsClass([document.getElementById("rslidy-overview-slides")], "rslidy-overview-visible");
        window.rslidy.utils.switchElementsClass([document.getElementById("rslidy-overview-slides")], "rslidy-invisible");
        window.rslidy.overview.adjustOverviewPanel();
        var visible = document.getElementById("rslidy-overview-slides").classList.contains("rslidy-overview-visible");
        document.getElementById("rslidy-button-overview").setAttribute("aria-expanded", String(visible));
        setTimeout(function () { return document.getElementById("rslidy-overview-slides").focus(); }, 100);
    };
    // ---
    // Description: Called whenever the help button is clicked.
    // ---
    ToolbarComponent.prototype.helpToggleClicked = function () {
        if (window.location.hash.match("#rslidy-help"))
            window.location.hash = "#";
        else {
            window.location.hash = "#rslidy-help";
            document.getElementById("rslidy-help-popup").scrollTop = 0;
            document.getElementById("rslidy-help").focus();
        }
    };
    // ---
    // Description: Called when clicking on the help overlay and closes the help
    // panel when clicking outside of the popup.
    // e: The click event
    // ---
    ToolbarComponent.prototype.closeHelpOnBlur = function (e) {
        if (e.target.id == "rslidy-help")
            window.location.hash = "#";
    };
    // ---
    // Description: Called whenever the toc button is clicked.
    // ---
    ToolbarComponent.prototype.tocToggleClicked = function () {
        window.rslidy.utils.switchElementsClass([document.getElementById("rslidy-overview-toc")], "rslidy-overview-visible");
        window.rslidy.utils.switchElementsClass([document.getElementById("rslidy-overview-toc")], "rslidy-invisible");
        var visible = document.getElementById("rslidy-overview-toc").classList.contains("rslidy-overview-visible");
        document.getElementById("rslidy-button-toc").setAttribute("aria-expanded", String(visible));
        setTimeout(function () { return document.getElementById("rslidy-overview-toc").focus(); }, 100);
    };
    // ---
    // Description: Called whenever the all slides button is clicked.
    // ---
    ToolbarComponent.prototype.displayToggleClicked = function () {
        if (this.allslides) {
            //find first visible slide
            var num = window.rslidy.content.currentSlideIndex;
            for (var i = 0; i < window.rslidy.num_slides; i++) {
                var slide = window.rslidy.utils.getSlide(i);
                if (window.rslidy.utils.checkVisible(slide)) {
                    num = i;
                    break;
                }
            }
            document.getElementsByTagName('head')[0].removeChild(this.allslides);
            this.allslides = null;
            if (this.enableiv)
                window.rslidy.image_viewer = true;
            if (this.printstyle)
                document.getElementsByTagName('head')[0].appendChild(this.printstyle);
            window.rslidy.content.showSlide(num, false);
        }
        else {
            var css = "\n      body {\n        background-color: white !important;\n      }\n      .rslidy-ui {\n        display: none !important;\n      }\n      a[href^=\"http://\"]:after, a[href^=\"https://\"]:after {\n        content: \"\" !important;\n      }\n      .slide.animated {\n        animation: none !important;\n      }\n      .slide, #rslidy-column-flex, #rslidy-row-flex {\n        display: block !important;\n        page-break-after: avoid !important;\n        page-break-inside: always !important;\n        -webkit-region-break-inside: always !important;\n        position: relative !important;\n      }\n      html,\n      body,\n      #rslidy-content-section, #rslidy-row-flex {\n        left: 0em !important;\n        right: 0em !important;\n        max-height: 100% !important;\n      }\n      img {\n        max-width: 100% !important;\n        max-height: 100% !important;\n      }\n      #rslidy-content-section {\n        counter-reset: slide-counter;\n      }\n      #rslidy-content-section .slide:after {\n        display: block;\n        content: counter(slide-counter);\n        counter-increment: slide-counter;\n        margin-top: 0.5em;\n        text-align: right;\n        font: 80% Sans-Serif;\n      }\n      .slide {\n        border: " + window.rslidy.print_frame + ";\n      }\n      #rslidy-trapezoid-wrapper-display {\n        display: block !important;\n      }";
            // inject CSS
            var style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = css;
            document.getElementsByTagName('head')[0].appendChild(style);
            this.allslides = style;
            if (window.rslidy.image_viewer) {
                this.enableiv = true;
                window.rslidy.image_viewer = false;
            }
            if (window.rslidy.printSettings.style) {
                this.printstyle = window.rslidy.printSettings.style;
                document.getElementsByTagName('head')[0].removeChild(this.printstyle);
            }
            //scroll to current slide
            var slide = window.rslidy.utils.getSlide(window.rslidy.content.currentSlideIndex);
            slide.scrollIntoView();
        }
        window.dispatchEvent(new Event('resize'));
    };
    // ---
    // Description: Wrapper for the custom settings close_menu_on_blur and
    // close_menu_on_selection
    // fun: An optional function to execute before closing menues
    // condition: The condition for closing the menues
    // ---
    ToolbarComponent.prototype.closeMenuWrapper = function (fun, condition) {
        if (fun === void 0) { fun = null; }
        if (fun)
            fun();
        if (condition)
            this.closeMenues();
    };
    // ---
    // Description: Close open menues on blur
    // ---
    ToolbarComponent.prototype.closeMenuOnBlur = function (fun) {
        if (fun === void 0) { fun = null; }
        this.closeMenuWrapper(fun, window.rslidy.close_menu_on_blur);
    };
    // ---
    // Description: Close open menues on selection
    // ---
    ToolbarComponent.prototype.closeMenuOnSelection = function (fun) {
        if (fun === void 0) { fun = null; }
        this.closeMenuWrapper(fun, window.rslidy.close_menu_on_selection);
    };
    // ---
    // Description: Closes all menues
    // ---
    ToolbarComponent.prototype.closeMenues = function () {
        document.getElementById("rslidy-menu").classList.add("rslidy-hidden");
        document.getElementById("rslidy-print-menu").classList.add("rslidy-hidden");
        document.getElementById("rslidy-button-menu").setAttribute("aria-expanded", "false");
        document.getElementById("rslidy-button-print").setAttribute("aria-expanded", "false");
    };
    // ---
    // Description: Called whenever a menu button is clicked.
    // index: The index of the menu (See constants in rslidy.ts)
    // ---
    ToolbarComponent.prototype.menuToggleClicked = function (index) {
        var menues = ["rslidy-menu", "rslidy-print-menu"];
        var buttons = ["rslidy-button-menu", "rslidy-button-print"];
        // Close other menu if open
        var close = document.getElementById(menues[(index + 1) % 2]);
        var closebtn = document.getElementById(buttons[(index + 1) % 2]);
        close.classList.add("rslidy-hidden");
        closebtn.setAttribute("aria-expanded", "false");
        // Toggle menu show status
        var menu = document.getElementById(menues[index]);
        var button = document.getElementById(buttons[index]);
        if (menu.classList.contains("rslidy-hidden")) {
            menu.classList.remove("rslidy-hidden");
            button.setAttribute("aria-expanded", "true");
        }
        else {
            menu.classList.add("rslidy-hidden");
            button.setAttribute("aria-expanded", "false");
        }
        menu.focus();
        // iOS13 requires permissions for both event handlers (workaround)
        // needs to come from a user fired event (e.g click)
        // the page needs to be https
        if (index == window.rslidy.MENU) {
            if (typeof window.DeviceMotionEvent.requestPermission === 'function') {
                window.DeviceMotionEvent.requestPermission()
                    .then(function (permissionState) {
                    if (permissionState === 'granted') {
                        window.addEventListener("devicemotion", function (e) {
                            window.rslidy.onDeviceMotion(e);
                        }.bind(window.rslidy));
                    }
                })
                    .catch(console.error);
            }
            if (typeof window.DeviceOrientationEvent.requestPermission === 'function') {
                window.DeviceOrientationEvent.requestPermission()
                    .then(function (permissionState) {
                    if (permissionState === 'granted') {
                        window.addEventListener("deviceorientation", function (e) {
                            window.rslidy.onDeviceOrientation(e);
                        }.bind(window.rslidy));
                    }
                })
                    .catch(console.error);
            }
        }
    };
    // ---
    // Description: Called whenever the show/hide toolbar button is clicked.
    // ---
    ToolbarComponent.prototype.showHideToggleClicked = function () {
        window.rslidy.utils.switchElementsClass([document.getElementById("rslidy-tb-show-trapezoid")], "rslidy-hidden");
        window.rslidy.utils.switchElementsClass([document.getElementById("rslidy-toolbar-area")], "rslidy-bar-hidden");
    };
    return ToolbarComponent;
}());
exports.ToolbarComponent = ToolbarComponent;
